"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormLabel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _FormLabel = require("./FormLabel.styled");
var _excluded = ["label", "className", "labelFor", "required", "hidden", "useAs"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FormLabel = exports.FormLabel = (0, _react.memo)(function (_ref) {
  var label = _ref.label,
    className = _ref.className,
    labelFor = _ref.labelFor,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$hidden = _ref.hidden,
    hidden = _ref$hidden === void 0 ? false : _ref$hidden,
    _ref$useAs = _ref.useAs,
    useAs = _ref$useAs === void 0 ? 'label' : _ref$useAs,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var LabelMarkup = {
    label: _react["default"].createElement(_FormLabel.StyledLabel, (0, _extends2["default"])({
      className: "".concat(className, " text-secondary"),
      htmlFor: labelFor,
      hidden: hidden
    }, props), label),
    span: _react["default"].createElement(_FormLabel.StyledSpan, (0, _extends2["default"])({
      className: "".concat(className, " text-secondary"),
      htmlFor: labelFor,
      hidden: hidden
    }, props), label)
  };
  return _react["default"].createElement(_react["default"].Fragment, null, required && _react["default"].createElement(_FormLabel.StyledAsterisk, {
    "data-testid": "required-asterisk",
    className: "text-danger",
    icon: _freeSolidSvgIcons.faAsterisk
  }), LabelMarkup[useAs]);
});
FormLabel.propTypes = {
  label: _propTypes["default"].string,
  className: _propTypes["default"].string,
  labelFor: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  hidden: _propTypes["default"].bool,
  useAs: _propTypes["default"].oneOf(['label', 'span'])
};